(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.ReactTransitionState = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],2:[function(require,module,exports){
"use strict";
"use client";

Object.defineProperties(exports, {
  __esModule: {
    value: true
  },
  [Symbol.toStringTag]: {
    value: "Module"
  }
});
const require_useTransitionState = require("./useTransitionState.cjs");
const require_useTransitionMap = require("./useTransitionMap.cjs");
exports.default = require_useTransitionState.useTransitionState;
exports.useTransition = require_useTransitionState.useTransitionState;
exports.useTransitionMap = require_useTransitionMap.useTransitionMap;
exports.useTransitionState = require_useTransitionState.useTransitionState;

},{"./useTransitionMap.cjs":4,"./useTransitionState.cjs":5}],3:[function(require,module,exports){
"use strict";
const STATUS = [
	"preEnter",
	"entering",
	"entered",
	"preExit",
	"exiting",
	"exited",
	"unmounted"
];
const getState = (status) => ({
	$: status,
	status: STATUS[status],
	isEnter: status < 3,
	isMounted: status !== 6,
	isResolved: status === 2 || status > 4
});
const startOrEnd = (unmounted) => unmounted ? 6 : 5;
const getEndStatus = (status, unmountOnExit) => {
	switch (status) {
		case 1:
		case 0: return 2;
		case 4:
		case 3: return startOrEnd(unmountOnExit);
	}
};
const getTimeout = (timeout) => typeof timeout === "object" ? [timeout.enter, timeout.exit] : [timeout, timeout];
const nextTick = (callback, config) => {
	config.r = requestAnimationFrame(() => {
		config.r = requestAnimationFrame(callback);
	});
};
//#endregion
exports.getEndStatus = getEndStatus;
exports.getState = getState;
exports.getTimeout = getTimeout;
exports.nextTick = nextTick;
exports.startOrEnd = startOrEnd;

},{}],4:[function(require,module,exports){
(function (process,global){(function (){
"use strict";
const require_internal = require("./internal.cjs");
let react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);
//#region src/useTransitionMap.ts
const updateState = (key, status, setStateMap, ref, config, onChange) => {
	if (config) {
		clearTimeout(config.t);
		cancelAnimationFrame(config.r);
	}
	const state = require_internal.getState(status);
	const stateMap = new Map(ref.m);
	stateMap.set(key, state);
	setStateMap(stateMap);
	ref.m = stateMap;
	onChange?.({
		key,
		current: state
	});
};
const useTransitionMap = ({ allowMultiple, enter = true, exit = true, preEnter, preExit, timeout, initialEntered, mountOnEnter, unmountOnExit, onStateChange: onChange } = {}) => {
	const [stateMap, setStateMap] = (0, react.useState)(/* @__PURE__ */ new Map());
	const [ref] = (0, react.useState)({
		m: stateMap,
		c: /* @__PURE__ */ new Map()
	});
	const [enterTimeout, exitTimeout] = require_internal.getTimeout(timeout);
	const setItem = (0, react.useCallback)((key, options) => {
		const { initialEntered: _initialEntered = initialEntered } = options || {};
		updateState(key, _initialEntered ? 2 : require_internal.startOrEnd(mountOnEnter), setStateMap, ref);
		ref.c.set(key, { r: 0 });
	}, [
		initialEntered,
		mountOnEnter,
		ref
	]);
	const deleteItem = (0, react.useCallback)((key) => {
		const newStateMap = new Map(ref.m);
		if (newStateMap.delete(key)) {
			setStateMap(newStateMap);
			ref.m = newStateMap;
			ref.c.delete(key);
			return true;
		}
		return false;
	}, [ref]);
	const endTransition = (0, react.useCallback)((key) => {
		const state = ref.m.get(key);
		if (!state) {
			if (process.env.NODE_ENV !== "production") console.error(`[React-Transition-State] cannot call endTransition: invalid key — ${key}`);
			return;
		}
		const status = require_internal.getEndStatus(state.$, unmountOnExit);
		if (status) updateState(key, status, setStateMap, ref, ref.c.get(key), onChange);
	}, [
		onChange,
		unmountOnExit,
		ref
	]);
	const toggle = (0, react.useCallback)((key, toEnter) => {
		const state = ref.m.get(key);
		if (!state) {
			if (process.env.NODE_ENV !== "production") console.error(`[React-Transition-State] cannot call toggle: invalid key — ${key}`);
			return;
		}
		const config = ref.c.get(key);
		const transitState = (status) => {
			updateState(key, status, setStateMap, ref, config, onChange);
			switch (status) {
				case 1:
					if (enterTimeout >= 0) config.t = setTimeout(() => endTransition(key), enterTimeout);
					break;
				case 4:
					if (exitTimeout >= 0) config.t = setTimeout(() => endTransition(key), exitTimeout);
					break;
				case 0:
				case 3:
					require_internal.nextTick(() => transitState(status + 1), config);
					break;
			}
		};
		const enterStage = state.isEnter;
		if (typeof toEnter !== "boolean") toEnter = !enterStage;
		if (toEnter) {
			if (!enterStage) {
				transitState(enter ? preEnter ? 0 : 1 : 2);
				if (!allowMultiple) ref.m.forEach((_, _key) => _key !== key && toggle(_key, false));
			}
		} else if (enterStage) transitState(exit ? preExit ? 3 : 4 : require_internal.startOrEnd(unmountOnExit));
	}, [
		ref,
		onChange,
		endTransition,
		allowMultiple,
		enter,
		exit,
		preEnter,
		preExit,
		enterTimeout,
		exitTimeout,
		unmountOnExit
	]);
	return {
		stateMap,
		toggle,
		toggleAll: (0, react.useCallback)((toEnter) => {
			if (!allowMultiple && toEnter !== false) return;
			for (const key of ref.m.keys()) toggle(key, toEnter);
		}, [
			allowMultiple,
			toggle,
			ref
		]),
		endTransition,
		setItem,
		deleteItem
	};
};
//#endregion
exports.useTransitionMap = useTransitionMap;

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./internal.cjs":3,"_process":1}],5:[function(require,module,exports){
(function (global){(function (){
"use strict";
const require_internal = require("./internal.cjs");
let react = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);
//#region src/useTransitionState.ts
const updateState = (status, setState, ref, onChange) => {
	clearTimeout(ref.t);
	cancelAnimationFrame(ref.r);
	const state = require_internal.getState(status);
	setState(state);
	ref.s = state;
	onChange?.({ current: state });
};
const useTransitionState = ({ enter = true, exit = true, preEnter, preExit, timeout, initialEntered, mountOnEnter, unmountOnExit, onStateChange: onChange } = {}) => {
	const [state, setState] = (0, react.useState)(() => require_internal.getState(initialEntered ? 2 : require_internal.startOrEnd(mountOnEnter)));
	const [ref] = (0, react.useState)({
		s: state,
		r: 0
	});
	const [enterTimeout, exitTimeout] = require_internal.getTimeout(timeout);
	const endTransition = (0, react.useCallback)(() => {
		const status = require_internal.getEndStatus(ref.s.$, unmountOnExit);
		if (status) updateState(status, setState, ref, onChange);
	}, [
		onChange,
		unmountOnExit,
		ref
	]);
	return [
		state,
		(0, react.useCallback)((toEnter) => {
			const transitState = (status) => {
				updateState(status, setState, ref, onChange);
				switch (status) {
					case 1:
						if (enterTimeout >= 0) ref.t = setTimeout(endTransition, enterTimeout);
						break;
					case 4:
						if (exitTimeout >= 0) ref.t = setTimeout(endTransition, exitTimeout);
						break;
					case 0:
					case 3:
						require_internal.nextTick(() => transitState(status + 1), ref);
						break;
				}
			};
			const enterStage = ref.s.isEnter;
			if (typeof toEnter !== "boolean") toEnter = !enterStage;
			if (toEnter) !enterStage && transitState(enter ? preEnter ? 0 : 1 : 2);
			else enterStage && transitState(exit ? preExit ? 3 : 4 : require_internal.startOrEnd(unmountOnExit));
		}, [
			ref,
			endTransition,
			onChange,
			enter,
			exit,
			preEnter,
			preExit,
			enterTimeout,
			exitTimeout,
			unmountOnExit
		]),
		endTransition
	];
};
//#endregion
exports.useTransitionState = useTransitionState;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./internal.cjs":3}]},{},[2])(2)
});
